var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"id":"password-field","label":((_vm.$t('login.fields.labels.password')) + " *"),"rules":_vm.rules,"error-messages":_vm.error},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }